import React, { useRef } from 'react';

// Draw-to-sign pad — the supplier signs with a mouse or finger. Emits a PNG
// data URL via onChange (null when cleared) which is embedded in the signed
// document.
//
// Extracted from ComplianceFormModal (now retired) so the full-page signer
// owns no private copy of it.
//
// ⚠️ STILL DUPLICATED: ComplianceAcknowledgeModal draws its own pad inline.
// That's a second implementation of the same evidence capture, so a fix to one
// won't reach the other — worth folding onto this component, but it's a
// separate change with its own testing (that flow uploads the PNG to storage
// and records the byte count, which this one doesn't do).
//
// Fixed internal resolution with pointer coords scaled to it, so the stored
// signature is the same size regardless of how wide the pad rendered.
export default function SignaturePad({ onChange, disabled }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const dirty = useRef(false);

  const point = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    const src = e.touches && e.touches[0] ? e.touches[0] : e;
    return { x: (src.clientX - r.left) * (c.width / r.width), y: (src.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => { if (disabled) return; e.preventDefault(); drawing.current = true; last.current = point(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = point(e);
    const g = canvasRef.current.getContext('2d');
    g.strokeStyle = '#131313'; g.lineWidth = 2.4; g.lineCap = 'round'; g.lineJoin = 'round';
    g.beginPath(); g.moveTo(last.current.x, last.current.y); g.lineTo(p.x, p.y); g.stroke();
    last.current = p; dirty.current = true;
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (dirty.current) onChange(canvasRef.current.toDataURL('image/png'));
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    dirty.current = false;
    onChange(null);
  };

  return (
    <div>
      <div className="relative">
        <canvas
          ref={canvasRef}
          width={560}
          height={150}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          aria-label="Signature — draw your signature here"
          className="w-full bg-white border border-line rounded-lg cursor-crosshair touch-none"
          style={{ height: 150, touchAction: 'none' }} />
        <span className="pointer-events-none absolute left-3 bottom-2 font-['Metropolis'] text-[11px] text-[#9BA08C]">Sign here with your mouse or finger</span>
      </div>
      <button type="button" onClick={clear} disabled={disabled}
        className="mt-1 font-['Metropolis'] text-[11px] font-semibold text-[#2F6E14] hover:underline disabled:opacity-50">
        Clear signature
      </button>
    </div>
  );
}
